// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q3-5";
export var filledCircle = "_q3-4";
export var historyEntry = "_q3-3";
export var messageSideLeft = "_q3-1";
export var messageSideRight = "_q3-2";
export var orderTrackingCarouselWrapper = "_q3-6";
export var orderTrackingInfoContainer = "_q3-0";